import { SinSidebarLayout } from 'layouts/SinSidebarLayout';
import { PreConfirmacion } from './components/PreConfirmacion';
import { Confirmacion } from './components/Confirmacion';
import { Cuerpo } from './components/Cuerpo';
import { SkeletonConcederAdministracion } from './components/SkeletonConcederAdministracion';
import { MensajeSolicitudRechazada } from './components/MensajeSolicitudRechazada';
import { MensajeSolicitudAprobada } from './components/MensajeSolicitudAprobada';
import { useConecederAdministracion } from './hooks/useConcederAdministracion';
import { MensajeDatosInsuficientes } from './components/MensajeDatosInsuficientes';

export const ConfirmarAdministracion = () => {
  const {
    ESTADOS,
    vista,
    data,
    isSubmiting,
    terminosAceptados,
    setVista,
    setTerminosAceptados,
    onConfirmarSolicitud
  } = useConecederAdministracion();

  if (vista === ESTADOS.LOADING) {
    return <SkeletonConcederAdministracion />;
  }

  if (vista === ESTADOS.ERROR_INICIAL) {
    return <MensajeDatosInsuficientes />;
  }

  if (vista === ESTADOS.SOLICITUD_RECHAZADA) {
    return <MensajeSolicitudRechazada />;
  }

  if (vista === ESTADOS.SOLICITUD_APROBADA) {
    return <MensajeSolicitudAprobada />;
  }

  return (
    <SinSidebarLayout containerClassName="xs:px-4 md:container md:mx-auto">
      <Cuerpo data={data}>
        {vista === ESTADOS.PRE_CONFIRMACION && (
          <PreConfirmacion
            data={data}
            onContinuar={() => setVista(ESTADOS.CONFIRMACION)}
          />
        )}
        {vista === ESTADOS.CONFIRMACION && (
          <Confirmacion
            terminosAceptados={terminosAceptados}
            setTerminosAceptados={setTerminosAceptados}
            onVolver={() => setVista(ESTADOS.PRE_CONFIRMACION)}
            onConfirmarSolicitud={onConfirmarSolicitud}
            isSubmiting={isSubmiting}
          />
        )}
      </Cuerpo>
    </SinSidebarLayout>
  );
};
